const LOGIN_HINT_KEY = "fido.auth.lastLoginHint";

/** A recovery signal only; it is never evidence that the app session is valid. */
export const getEntraLoginHint = (): string | null => {
  try {
    return localStorage.getItem(LOGIN_HINT_KEY);
  } catch {
    return null;
  }
};

export const setEntraLoginHint = (loginHint: string): void => {
  try {
    localStorage.setItem(LOGIN_HINT_KEY, loginHint);
  } catch {
    /* storage may be unavailable */
  }
};

export const clearEntraLoginHint = (): void => {
  try {
    localStorage.removeItem(LOGIN_HINT_KEY);
  } catch {
    /* storage may be unavailable */
  }
};
